var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import { withSearch } from "..";
import { ResultsPerPage } from "@elastic/react-search-ui-views";
export class ResultsPerPageContainer extends Component {
    render() {
        const _a = this.props, { className, resultsPerPage, setResultsPerPage, options, view } = _a, rest = __rest(_a, ["className", "resultsPerPage", "setResultsPerPage", "options", "view"]);
        const View = view || ResultsPerPage;
        const viewProps = Object.assign({ className, onChange: (value) => {
                setResultsPerPage(value);
            }, options, value: resultsPerPage }, rest);
        return React.createElement(View, Object.assign({}, viewProps));
    }
}
ResultsPerPageContainer.defaultProps = {
    options: [20, 40, 60]
};
export default withSearch(({ resultsPerPage, setResultsPerPage }) => ({
    resultsPerPage,
    setResultsPerPage
}))(ResultsPerPageContainer);
